import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BtnLoadingComponent } from './btn-loading.component';

const components = [
    BtnLoadingComponent
];

@NgModule({
  imports: [
    NgbModule, 
    CommonModule
  ],
  declarations: components,
  exports:components,
})
export class BtnLoadingModule { }